import PropTypes from "prop-types";
import { QRCodeCanvas } from "qrcode.react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useRef, useState } from "react";
import { adminGenerateCheckoutQrCode } from "helpers/backend_helpers";
import { toast } from "react-toastify";

const QrCloseModal = ({ show, onCloseClick, data }: any) => {
  const qrRef = useRef<HTMLDivElement>(null);
  const [qrCheckout, setQrCheckout] = useState<string>("");
  const [isRegenerating, setIsRegenerating] = useState<boolean>(false);

  const regenerateQR = async () => {
    setIsRegenerating(true);
    await adminGenerateCheckoutQrCode(data._id, {})
      .then((response: any) => {
        setQrCheckout(response);
        toast.success("Berhasil memperbarui QR absen keluar");
      })
      .catch((error) => {
        toast.error("Gagal memperbarui QR code");
      })
      .finally(() => {
        setIsRegenerating(false);
      });
  };

  const downloadQRCode = () => {
    if (!qrRef.current) return;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const scale = 3;

    const width = 400 * scale;
    const height = 550 * scale;
    canvas.width = width;
    canvas.height = height;

    ctx.scale(scale, scale);

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, 400, 550);

    ctx.strokeStyle = "#e5e7eb";
    ctx.lineWidth = 2;
    ctx.strokeRect(10, 10, 380, 530);

    const qrCanvas = qrRef.current.querySelector("canvas");
    if (qrCanvas) {
      const qrSize = 250;
      const qrX = (400 - qrSize) / 2;
      const qrY = 60;

      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";

      ctx.drawImage(qrCanvas, qrX, qrY, qrSize, qrSize);
    }

    ctx.fillStyle = "#1f2937";
    ctx.textAlign = "center";

    ctx.font = "bold 20px Arial";
    ctx.fillText("ABSEN KELUAR", 200, 350);

    ctx.font = "bold 24px Arial";
    ctx.fillText(data?.name || "", 200, 390);

    ctx.font = "18px Arial";
    ctx.fillText(`${data?.checkOutTime || ""}`, 200, 425);

    ctx.font = "14px Arial";
    ctx.fillStyle = "#6b7280";
    ctx.fillText("Scan QR Code untuk absen", 200, 480);

    const link = document.createElement("a");
    link.download = `QR-Absen-Keluar-${data?.name || "attendance"}.png`;
    link.href = canvas.toDataURL("image/png", 1.0);
    link.click();
  };

  return (
    <Modal
      size="md"
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
    >
      <ModalHeader className="border-0 pb-0" toggle={onCloseClick}>
        <div className="text-grey">
          <h5 className="mb-1">QR Code Absensi Keluar</h5>
        </div>
      </ModalHeader>
      <ModalBody className="pt-4 pb-4">
        <div ref={qrRef} className="text-center">
          <div
            className="d-inline-block p-4 mb-3"
            style={{
              background: "white",
              borderRadius: "16px",
              boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
              border: "1px solid #e5e7eb",
            }}
          >
            <QRCodeCanvas
              value={qrCheckout || data?._id || ""}
              title={data?.name}
              size={200}
              bgColor={"#ffffff"}
              fgColor={"#1f2937"}
              level={"H"}
            />
          </div>

          <div
            className="mx-auto p-3"
            style={{
              maxWidth: "300px",
              background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
            }}
          >
            <div className="mb-2">
              <span
                className="badge"
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  fontSize: "0.75rem",
                  padding: "0.35rem 0.75rem",
                }}
              >
                ABSEN KELUAR
              </span>
            </div>
            <h5 className="mb-2 fw-bold" style={{ color: "#1f2937" }}>
              {data?.name}
            </h5>
            <div
              className="d-flex align-items-center justify-content-center gap-2"
              style={{ fontSize: "0.95rem", color: "#4b5563" }}
            >
              <i className="las la-clock"></i>
              <span className="fw-semibold">{data?.checkOutTime}</span>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="border-0 pt-0">
        <button
          type="button"
          className="btn btn-light waves-effect waves-light material-shadow-none btn-sm"
          onClick={onCloseClick}
        >
          Tutup
        </button>
        <button
          type="button"
          className="btn btn-warning waves-effect waves-light material-shadow-none btn-sm"
          onClick={regenerateQR}
          disabled={isRegenerating}
        >
          {isRegenerating ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Memperbarui...
            </>
          ) : (
            <>
              <i className="ri-refresh-line me-1"></i>
              Generate QR Baru
            </>
          )}
        </button>
        <button
          type="button"
          className="btn waves-effect waves-light material-shadow-none btn-sm"
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            border: "none",
          }}
          onClick={downloadQRCode}
        >
          <i className="ri-download-2-line me-1"></i>
          Download QR Code
        </button>
      </ModalFooter>
    </Modal>
  );
};

QrCloseModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  getData: PropTypes.func,
  data: PropTypes.any,
};

export default QrCloseModal;
